<section class="container mt-5">
  <bn-paginacao [total]="portes.length" [tamanhoPagina]="atributosPaginacao.pageSize"
    [numPagina]="atributosPaginacao.page" [opcoesTamanhoPagina]="[10, 20, 30]" (aoMudar)="mudancaPagina($event)">
    <div class="table-responsive">
      <table class="table table-hover">
        <thead>
          <tr>
            <th scope="col">Sigla do Porte</th>
            <th scope="col">Nome do Porte</th>
            <th scope="col">Sigla Apuração Valor Stop Loss</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let item of portes">
            <td>{{ item.sigla }}</td>
            <td>{{ item.descricao }}</td>
            <td>{{ item.siglaApuracaoValorLiberadoStopLoss }}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </bn-paginacao>
</section>
